import clsx from 'clsx';

export const chatInputWrapperClassName = ({
  disabled,
  error,
  isFocus,
}: {
  disabled: boolean;
  error: boolean;
  isFocus: boolean;
}) =>
  clsx(
    'border',
    'bg-white',
    'text-gray_600',
    'placeholder-gray-400',
    'text-paragraph_m',
    'font-regular',
    'rounded',
    'block',
    // 'w-full',
    'w-[224px]',
    'inline-flex',
    'items-center',
    'px-[12px]',
    'py-[4px]',
    'transition',
    disabled
      ? 'border-gray_300 bg-gray_100'
      : error
      ? 'border-negative_500'
      : isFocus
      ? 'border-primary_400'
      : 'border-gray_300 text-gray_400 hover:border-gray_400',
  );

export const chatInputClassName = clsx(
  'border-none',
  'focus:border-none',
  'outline-0',
  'focus:outline-0',
  'w-full',
  'text-gray_500',
  'disabled:bg-gray_100',
  'disabled:text-gray_400',
);
